
import {defineComponent} from "vue";
import {CbStructureMixin} from "@/components/layouts/content-pages/wysiwyg/structures/CbStructureMixin";
import {NormalContentBlockRestService} from "@/services/rest/cms-content-block/NormalContentBlockRestService";
import {FindNormalContentBlockPayload} from "@/models/payload/FindNormalContentBlockPayload";
import {CreateNormalContentBlockPayload} from "@/models/payload/CreateNormalContentBlockPayload";
import {SaveNormalContentBlockPayload} from "@/models/payload/SaveNormalContentBlockPayload";
import {RowSeparatorContentRestDtoModel} from "@/models/RowSeparatorContentRestDtoModel";
import {
  CodeDescriptionRestDto,
} from "@/api/pharma-cms-content-block/models";
import {createCodeDescriptionArrayFromEnum} from "@/helpers/functions/enum";
import {EnumClassNameCmsEnum} from "@/models/enum/EnumClassNameCmsEnum";
import {HeightEnum} from "@/api/enums/height-enum";
import BaseSpinner from "@/components/UI/Bootstrap/BaseSpinner.vue";
import InputSelect from "@/components/UI/InputSelect.vue";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";

export default defineComponent({
  name: "CbRowSeparator",
  components: {InputSelect, BaseSpinner},
  extends: CbStructureMixin,
  data: () => ({
    contentBlock: RowSeparatorContentRestDtoModel.createWithDefaults(),
    enumBackgroundColorCode: [] as CodeDescriptionRestDto[],
  }),
  mounted() {
    this.initialize();
  },
  computed: {
    enumHeightCode(): CodeDescriptionRestDto[] {
      // todo !!!
      return createCodeDescriptionArrayFromEnum(HeightEnum);
    }
  },
  methods: {
    async find(payload: FindNormalContentBlockPayload): Promise<RowSeparatorContentRestDtoModel> {
      return await NormalContentBlockRestService.getInstance().findRowSeparator(payload.type, payload.id);
    },
    async create(payload: CreateNormalContentBlockPayload): Promise<string> {
      return await NormalContentBlockRestService.getInstance().createRowSeparator(payload.cb as RowSeparatorContentRestDtoModel, payload.type);
    },
    async save(payload: SaveNormalContentBlockPayload): Promise<void> {
      await NormalContentBlockRestService.getInstance().saveRowSeparator(payload.cb as RowSeparatorContentRestDtoModel, payload.type, payload.id);
    },
    async initialize(): Promise<void> {
      this.enumBackgroundColorCode = await EnumRestService.getInstance().getEnumValuesByClassName(EnumClassNameCmsEnum.BACKGROUND_COLOR, DpModuleEnum.CMS);
    },
    getDefaultCbModel(): RowSeparatorContentRestDtoModel {
      return RowSeparatorContentRestDtoModel.createWithDefaults();
    },
    determineEnums(): EnumClassNameCmsEnum[] {
      return [
        EnumClassNameCmsEnum.BACKGROUND_COLOR,
      ];
    },
    pasteCbMetadata(): void {
      this.contentBlock.cloneMetadataFrom(this.getClipboardContentBlock(this.cbType) as RowSeparatorContentRestDtoModel);
    },
  }
});
